import reducer from './reducers';

export { default as modalOperations } from "./operations";
export { default as modalTypes } from "./types";

export default reducer;